import { PopoverMenu as DesignSystemPopoverMenu } from '@factorialco/deprecated-design-system'

const PopoverMenu = (props: React.ComponentProps<typeof DesignSystemPopoverMenu>) => {
  return <DesignSystemPopoverMenu {...props} />
}

export type PopoverMenuTouchableOptionProps = React.ComponentProps<
  typeof DesignSystemPopoverMenu.TouchableOption
>

PopoverMenu.Trigger = DesignSystemPopoverMenu.Trigger
PopoverMenu.Content = DesignSystemPopoverMenu.Content
PopoverMenu.HrefOption = function HrefOption(
  props: Omit<React.ComponentProps<typeof DesignSystemPopoverMenu.HrefOption>, 'extraContent'>
) {
  return <DesignSystemPopoverMenu.HrefOption {...props} extraContent={null} />
}
PopoverMenu.RouterOption = function RouterOption(
  props: Omit<React.ComponentProps<typeof DesignSystemPopoverMenu.RouterOption>, 'extraContent'>
) {
  return <DesignSystemPopoverMenu.RouterOption {...props} extraContent={null} />
}
PopoverMenu.TouchableOption = function TouchableOption(props: PopoverMenuTouchableOptionProps) {
  return <DesignSystemPopoverMenu.TouchableOption {...props} extraContent={props.extraContent} />
}
PopoverMenu.Close = DesignSystemPopoverMenu.Close
PopoverMenu.Portal = DesignSystemPopoverMenu.Portal

export default PopoverMenu
